<template>
  <div>
    <!-- Selector principal -->
    <v-select
      class="select-style"
      v-model="selectedRange"
      :items="rangeOptions"
      label="Periodo"
      outlined
      variant="plain"
      style="width: 150px;"
      @update:modelValue="onRangeChange"
    />

    <!-- Date range picker (solo si eligen personalizado) -->
    <v-dialog v-model="showDatePicker" max-width="400">
      <v-card>
        <v-card-title>Seleccionar periodo</v-card-title>
        <v-card-text>
          <!-- Aquí se usa multiple para permitir seleccionar dos fechas -->
          <v-date-picker
            v-model="customRange"
            multiple
            :max="2"
            show-current="false"
            hide-header
            />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showDatePicker = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, subDays, subYears } from 'date-fns'

export default {
  name: 'DateRangePicker',
  emits: ['update:dates'],
  data () {
    const today = new Date()
    return {
      selectedRange: 'Este mes',
      rangeOptions: [
        'Hoy',
        'Ayer',
        'Esta semana',
        'Este mes',
        'Este año',
        'Año pasado',
        'Seleccionar periodo'
      ],
      selectedDates: { start: startOfMonth(today), end: endOfMonth(today) },
      showDatePicker: false,
      customRange: []
    }
  },
  watch: {
    selectedDates: {
      deep: true,
      immediate: true,
      handler (val) {
        this.$emit('update:dates', val)
      }
    },
    customRange (val) {
      if (val.length === 2) {
        const sorted = [...val].sort((a, b) => new Date(a) - new Date(b))
        this.selectedDates = { start: sorted[0], end: sorted[1] }
        this.showDatePicker = false // cerrar automáticamente
      }
    }
  },
  methods: {
    onRangeChange (value) {
      const today = new Date()

      switch (value) {
        case 'Hoy':
          this.selectedDates = { start: today, end: today }
          break
        case 'Ayer':
          this.selectedDates = { start: subDays(today, 1), end: subDays(today, 1) }
          break
        case 'Esta semana':
          this.selectedDates = { start: startOfWeek(today, { weekStartsOn: 1 }), end: endOfWeek(today, { weekStartsOn: 1 }) }
          break
        case 'Este mes':
          this.selectedDates = { start: startOfMonth(today), end: endOfMonth(today) }
          break
        case 'Este año':
          this.selectedDates = { start: startOfYear(today), end: endOfYear(today) }
          break
        case 'Año pasado':
          this.selectedDates = { start: startOfYear(subYears(today, 1)), end: endOfYear(subYears(today, 1)) }
          break
        case 'Seleccionar periodo':
          this.customRange = []
          this.showDatePicker = true
          break
      }
    },
    applyCustomRange () {
      if (this.customRange.length === 2) {
        // ordenar fechas por si el usuario selecciona al revés
        const sorted = [...this.customRange].sort((a, b) => new Date(a) - new Date(b))
        this.selectedDates = { start: sorted[0], end: sorted[1] }
      }
      this.showDatePicker = false
    },
    formatDate (date) {
      return new Date(date).toLocaleDateString('es-MX')
    }
  }
}
</script>

<style scoped>
    .select-style .v-field {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
</style>
